export default "__VITE_ASSET__as8R5$nd__"